<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>구분</h5>
      <div class="writeGridContainer">
        <div v-if="isPrint" class="print-input text-right">{{ form.yearType }}</div>
        <div v-else>
          <vs-radio class="mr-4" v-model="form.yearType" vs-value="상반기" color="secondary" :disabled="board.readonly">상반기</vs-radio>
          <vs-radio v-model="form.yearType" vs-value="하반기" color="secondary" :disabled="board.readonly">하반기</vs-radio>
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 교육 구분</h5>
      <div class="grid grid-cols-4 gap-x-6 gap-y-4 mt-4">
        <div v-for="(_title, _title_i) in eduType" :key="`checkbox_${_title}`" class="col-span-1 flex items-center">
          <div v-if="isPrint || board.readonly" class="flex items-center">
            <div v-if="form.eduTypeChecked.includes(_title)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
            <span class="flex-1">
              {{ _title }}
            </span>
          </div>
          <div v-else>
            <span class="flex">
              <vs-checkbox v-model="form.eduTypeChecked" :vs-value="_title">{{ _title }}</vs-checkbox>
            </span>
          </div>
        </div>
      </div>
    </div>

    <table-custom
      v-show="form.eduTypeChecked.includes('안전관리자 등 교육이수 계획')"
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      :title="'<i class=\'dot\'></i>안전관리자 등 교육이수 계획'"
      :title-type="'tooltip'"
      :tooltip-head="'※ 작성방법'"
      :tooltip-body="'- 소관 시설물과 관련된 모든 교육대상자의 교육이수 계획 수립<br>'+
'※ 아래 법령은 작성을 위한 예시이므로 소관시설물에 대해 추가해야할 법령 및 교육대상이 있을 경우 포함하여 작성'"
      :popup-head="'작성방법'"
      :popup-body="'- 소관 시설물과 관련된 모든 교육대상자의 교육이수 계획 수립<br>'+
'<p style=\'color:#7E72F2\'>※ 아래 법령은 작성을 위한 예시이므로 소관시설물에 대해 추가해야할 법령 및 교육대상이 있을 경우 포함하여 작성</p>'"
      :tableData="[
        { id: 'target', title: '교육대상', type: 'text', placeholder: '' },
        { id: 'process', title: '교육과정', type: 'text', placeholder: '' },
        { id: 'date', title: '교육시간', type: 'text', placeholder: '' },
        { id: 'method', title: '교육방법', type: 'text', placeholder: '' },
        { id: 'note', title: '비고', type: 'text', placeholder: '' },

      ]"
      :mobile="['target', 'process']"
      v-model="form.tableList1"
      class="mt-4"
    />

    <table-custom
      v-show="form.eduTypeChecked.includes('안전관리자 등 교육이수 계획(대상자를 위탁운영하고 있을 경우)')"
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      :title="'<i class=\'dot\'></i>안전관리자 등 교육이수 계획 <span style=\'font-size: 14px; color:#7E72F2;\'>※ 대상자를 위탁운영하고 있을 경우</span>'"
      :title-type="'tooltip'"
      :tooltip-head="'※ 작성방법'"
      :tooltip-body="'- 소관 시설물과 관련된 모든 교육대상자의 교육이수 계획 수립<br>'+
'※ 아래 법령은 작성을 위한 예시이므로 소관시설물에 대해 추가해야할 법령 및 교육대상이 있을 경우 포함하여 작성'"
      :popup-head="'작성방법'"
      :popup-body="'- 소관 시설물과 관련된 모든 교육대상자의 교육이수 계획 수립<br>'+
'<p style=\'color:#7E72F2\'>※ 아래 법령은 작성을 위한 예시이므로 소관시설물에 대해 추가해야할 법령 및 교육대상이 있을 경우 포함하여 작성</p>'"
      :tableData="[
        { id: 'target', title: '교육대상', type: 'text', placeholder: '' },
        { id: 'process', title: '교육과정', type: 'text', placeholder: '' },
        { id: 'date', title: '교육시간', type: 'text', placeholder: '' },
        { id: 'method', title: '교육방법', type: 'text', placeholder: '' },
        { id: 'note', title: '비고', type: 'text', placeholder: '' },

      ]"
      :mobile="['target', 'process']"
      v-model="form.tableList2"
      class="mt-4"
    />

    <table-custom
      v-show="form.eduTypeChecked.includes('교육 이수현황')"
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="교육 이수현황"
      :tableData="[
        { id: 'target', title: '교육대상', type: 'text', placeholder: '소방안전관리자' },
        { id: 'take', title: '이수여부', type: 'radio', middle: true, radioItems: [{ value: '이수' }, { value: '미이수' }], width: '150px', },
        { id: 'plan', title: '이수일/이수계획', type: 'date', placeholder: '날짜선택' },
        { id: 'reason', title: '미이수 사유', type: 'customType', },
        { id: 'note', title: '비고', type: 'text', placeholder: '00.00까지 선임예정' },

      ]"
      :mobile="['target', 'take']"
      v-model="form.tableList3"
      class="mt-4"
    >
      <template #customType="{ trData, value, input }">
        <input v-if="!!trData && !!trData.take && trData.take === '미이수'" :readonly="board.readonly" class="w-full flex-1" :value="value" @input="(e) => input(e.target.value)" placeholder="위험물관리자 변경(선임 6개월이내 이수)" />
      </template>
      <template #customTr="{ isMobile }">
        <tr style="background: #f9f9f9 !important">
          <td v-if="!isPrint"></td>
          <td style="padding: 10px 15px;" :colspan="isMobile ? 3 : 5 ">
            <div class="flex" style="place-content: center;">
              <div class="mx-10" style="align-self: center;">합계</div>
              <comma-input readonly placeholder="자동입력" v-model="form.takeSum"  />
              <div class="mx-10" style="align-self: center;">이수자 수</div>
              <comma-input readonly placeholder="자동입력" v-model="form.taken" />
              <div class="mx-10" style="align-self: center;">미이수자 수</div>
              <comma-input readonly placeholder="자동입력" v-model="form.untaken"  />
            </div>
          </td>
        </tr>
      </template>
    </table-custom>
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import SearchNavStartEnd from "../../../../components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "../../../modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";

export default {
  components: {
    PopupLoadPrevBoard,
    PhotoUploadGridModule,
    TableCustom,
    TimeSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.tableList3': {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.length !== 0) {
          this.form.taken = 0
          this.form.untaken = 0
          for(const item of this.form.tableList3) {
            if (item.take === '이수') {
              this.form.taken += 1
            } else if (item.take === '미이수') {
              this.form.untaken += 1
            }
          }
          this.form.takeSum = this.form.taken + this.form.untaken
        }
      },
    },
  },
  data() {
    return {
      eduType: ["안전관리자 등 교육이수 계획", "안전관리자 등 교육이수 계획(대상자를 위탁운영하고 있을 경우)", "교육 이수현황"],
      form: {
        stdInfo: {},

        yearType: "상반기",
        eduTypeChecked: [],

        tableList1: [
          { "id": 1, "undefined": {}, "target": "", "process": "", "date": "", "method": "", "note": "" },
          { "id": 2, "undefined": {}, "target": "", "process": "", "date": "", "method": "", "note": "" }
        ],
        tableList2: [
          { "id": 1, "undefined": {}, "target": "", "process": "", "date": "", "method": "", "note": "" },
          { "id": 2, "undefined": {}, "target": "", "process": "", "date": "", "method": "", "note": "" }
        ],
        tableList3: [],

        taken: 0,
        untaken: 0,
        takeSum: 0,

        fileList: [],
      },
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
input {
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  padding: 0.7rem !important;
  transition: all 0.3s ease;
  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}
</style>
